export default {
  type: "Document type",
};
